import(/* webpackMode: "eager" */ "/codebuild/output/src2996922085/src/atua-frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2996922085/src/atua-frontend/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2996922085/src/atua-frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Quicksand\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2996922085/src/atua-frontend/src/app/Provider.tsx");
